import { SESSIONS_TEST_IDS } from '@/components/admin/sessions/contracts';
import { costLabel } from '@/lib/session-labels';
import type { SessionConversationBubble } from '@matter_extractor/shared';
import { Icon } from '@pms-digital/design-system';
import { bubblePageRank } from './conversation-fil';

/**
 * The separator that opens a page played IN the conversation (prolongation.md §7,
 * planche `sessions.html`): « Page 7 · Le mail », the pill « dans la
 * conversation », and on the right « 1 bulle · 0,01 € ».
 *
 * ## It wears the step band's drawing and is not one
 *
 * Same strip, same type - the eye reads the fil by its bands - but on a lighter
 * wash of the same blue and with a pill, so that a page of the thread is never
 * read for a step of the protocol. It is NOT a `StepBandRow`, because it counts
 * nothing a step counts: no turns, no cap, no attempt, and its figure is the cost
 * of its one bubble. The rank is the page's rank in the walk, the number
 * Parcours prints on the card - « Page 7 » is the same page on both screens.
 *
 * The cost is the bubble's STORED one, to the cent like every band: the call
 * itself is read in the Appels layer, to the thousandth.
 */

export interface PageBandRowProps {
  bubble: SessionConversationBubble;
}

export function PageBandRow({ bubble }: PageBandRowProps) {
  return (
    <li
      data-testid={SESSIONS_TEST_IDS.bubbleBand}
      data-visit={bubble.visitIndex}
      data-page-id={bubble.pageId}
      data-bubbles={1}
      className="flex flex-wrap items-center gap-x-3 gap-y-1 border-gray-200 border-y bg-bleu-nuit-tint/50 px-5 py-2 font-semibold text-bleu-nuit text-caption uppercase tracking-wide"
    >
      <span className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span>
          Page {bubblePageRank(bubble)} · {bubble.pageName}
        </span>
        <span className="inline-flex items-center gap-1 rounded-full bg-white px-2 font-semibold normal-case tracking-normal ring-1 ring-bleu-nuit/20 ring-inset">
          <Icon name="chat_bubble" size={14} />
          dans la conversation
        </span>
      </span>
      <span className="ml-auto font-normal text-bleu-nuit-deep normal-case tracking-normal">
        1 bulle · {costLabel(bubble.costEur)}
      </span>
    </li>
  );
}
